import { UNIFIED_HUNK_HEADER_RE } from './constants.js';

export async function consumeUnifiedHunkBody(options: {
  all: string[];
  startIndex: number;
  out: string[];
  maybeYield: () => Promise<void>;
}): Promise<{ nextIndex: number; oldConsumed: number; newConsumed: number }> {
  let i = options.startIndex;
  let oldConsumed = 0;
  let newConsumed = 0;

  while (i < options.all.length) {
    await options.maybeYield();
    const bl = options.all[i]!;
    if (UNIFIED_HUNK_HEADER_RE.test(bl)) break;
    options.out.push(bl);
    i++;
    if (bl.startsWith('\\')) continue;
    const ch = bl[0];
    if (ch === ' ') {
      oldConsumed++;
      newConsumed++;
    } else if (ch === '-') {
      oldConsumed++;
    } else if (ch === '+') {
      newConsumed++;
    }
  }

  return { nextIndex: i, oldConsumed, newConsumed };
}
